var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.pageshow),expression:"$store.state.pageshow"}]},[_c('LinePic'),_c('MyHeader'),_c('router-view')],1),_c('iframe',{attrs:{"src":"./mms3D/index.html","id":"iframe"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }